import actionTypes from '../constants/actionTypes/summary-action-types';

export const setSummaryData = (price, pluspaketCoveragesPrice) => ({
    type: actionTypes.SET,
    payload: { price, pluspaketCoveragesPrice }
});
